import type { HtmlNodeFragment } from '@haaretz/s-fragments/HTMLNode';

const htmlNodeTypename: HtmlNodeFragment['__typename'] = 'HtmlNode';

export default function isHtmlNode(item: { __typename?: string }): item is HtmlNodeFragment {
  if (!(item instanceof Object)) return false;

  return item.__typename === htmlNodeTypename;
}
